import React from 'react'
import { useSelector } from 'react-redux'
import { appErrorSelector } from '@redux/slices/workflowSlice'
import { Button } from '@components/ui-css/Button/Button'
import { useInteractionContext } from '@components/interactionContext/useInteractionContext'
import { useAppTranslation } from '@hooks/useAppTranslation'

type ErrorCTAProps = {
  ctaLabel?: string
}

export const ErrorCTA: React.FC<ErrorCTAProps> = ({ ctaLabel }) => {
  const { t } = useAppTranslation({ keyPrefix: 'ErrorPage' })
  const error = useSelector(appErrorSelector)
  const { pushFallbackInteraction } = useInteractionContext()

  if (typeof error?.ctaCallback !== 'function') {
    return null
  }

  const onClick = () => {
    pushFallbackInteraction('retry')
    error?.ctaCallback?.()
  }

  return <Button onClick={onClick}>{ctaLabel ?? t('body.ctaLabel')}</Button>
}
